import CreatableTagsSelect from './CreatableTagsSelect';

export default CreatableTagsSelect;
